import axios from 'axios';

const DEV_URL = `${process.env.REACT_APP_API}/v3`;
const PROD_URL = process.env.REACT_APP_API_AUTH_URL ?? 'https://auth.movingpay.com.br/v1';

const baseURL = process.env.REACT_APP_ENV !== 'production' ? DEV_URL : PROD_URL;

export const auth = axios.create({
  baseURL,
  timeout: 120000
});